module.exports = __webpack_public_path__ + "img/wellborn-logo.5cbff823.jpg";